  <template>
    <Claims />
  </template>
  
  <script>
  import Claims from "@/components/Ondemand/Bookings/Claims.vue";
  export default {
    components: {
      Claims
    },
  };
  </script>
  
 
 